import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pending",
  "use": "icon-pending-usage",
  "viewBox": "0 0 37 37",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 37 37\" id=\"icon-pending\"><circle cx=\"18\" cy=\"18\" r=\"16.5\" fill=\"#FFF\" fill-rule=\"evenodd\" stroke=\"#099\" stroke-width=\"3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol